import { useState } from 'react';
import Highlighter from 'react-highlight-words';
import { useRouter } from 'next/router';
import { AutoComplete, Button, Col, Collapse, Grid, Input, Row, Typography } from 'antd';
import ImageC from 'src/components/Image';
import { FAQCategories, FAQQuestions } from 'src/utils/dummy/faq/content';

import collapseClasses from '../../components/AccordionContent/index.module.css';
import classes from './index.module.css';
import cn from "src/utils/cn";

const { Title } = Typography;

const ContainerPage = () => {
	const { sm } = Grid.useBreakpoint();
	const router = useRouter();
	const [options, setOptions] = useState<any>([]);

	const favouriteQuestions = FAQQuestions.slice(0, 5);

	const PanelTitle = (props: { title: string }) => {
		return <h5 className={collapseClasses['panel-title']}>{props.title}</h5>;
	};

	const IconExpandUp = () => {
		return <ImageC alt="Icon Arrow" height={6} width={10} src="/icons/arrow-chevron-up.svg" />;
	};

	const IconExpandDown = () => {
		return <ImageC alt="Icon Arrow" height={6} width={10} src="/icons/arrow-chevron-down.svg" />;
	};

	const generateSearchResult = (queryTarget: string) => {
		const keywords = queryTarget.trim().split(' ');
		let suggestedQuestions = FAQQuestions.filter((q: any) => {
			const allow: boolean = keywords.some((k: string) => {
				return q.title.toLowerCase().indexOf(k.toLowerCase()) > -1;
			});

			return allow;
		});

		suggestedQuestions = suggestedQuestions.slice(0, 4);

		return suggestedQuestions.map((question, idx) => {
			let hideBorder = false;
			if (idx + 1 === suggestedQuestions.length) {
				hideBorder = true;
			}

			const Highlight = ({ children }: { children: any }) => (
				<strong className={classes['highlighted-text']}>{children}</strong>
			);

			let topicName = 'umum';
			if (question.slug_category) {
				topicName = question.slug_category;
			}
			return {
				value: `${question.slug}`,
				label: (
					<div
						className={cn(
							{
								[classes['show-divider']]: !hideBorder,
							},
							classes['box-result-search'],
						)}
					>
						<Button
							type="text"
							className={classes['row-suggest']}
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								router.push(`/faq/${topicName}/${question.slug}`);
							}}
						>
							<Highlighter
								activeClassName={classes['highlight-text']}
								searchWords={queryTarget.trim().split(' ')}
								textToHighlight={question.title}
								highlightTag={Highlight}
							/>
						</Button>
					</div>
				),
			};
		});
	};

	const handleSearch = (value: string) => {
		if (value.length >= 3) {
			setOptions(value ? generateSearchResult(value) : []);
		} else {
			setOptions([]);
		}
	};

	return (<>
        <div className={classes['page-header-wrap']}>
            <div className="container">
                <div className={classes['page-header']}>
                    <Title level={1} className={classes['subtitle-text']}>
                        Pusat Bantuan KlikDokter
                    </Title>
                    <Title level={2} className={classes['title-text']}>
                        Hi, ada yang bisa kami bantu?
                    </Title>
                    <div className={classes['section-autocomplete']}>
                        <AutoComplete
                            onSearch={handleSearch}
                            options={options}
                            className={classes['autocomplete-root']}
                            popupClassName={classes['box-result']}
                        >
                            <Input.Search
                                size="large"
                                placeholder="Ketik yang Kamu cari"
                                enterButton
                                name="keyword"
                                className={classes['search-btn']}
                                onPressEnter={(element: any) => {
                                    if (
                                        element.target &&
                                        element.target.value &&
                                        element.target.value.length >= 3
                                    ) {
                                        const searchKeyword = encodeURI(element.target.value);
                                        router.push(`/faq/search?q=${searchKeyword}`);
                                    }
                                    return false;
                                }}
                                onSearch={(value: any) => {
                                    if (value) {
                                        const searchKeyword = encodeURI(value);
                                        router.push(`/faq/search?q=${searchKeyword}`);
                                    }
                                    return false;
                                }}
                            />
                        </AutoComplete>
                    </div>
                </div>
            </div>
        </div>
        <div className={classes['page-body-wrap']}>
            <div className="container">
                <div className={classes['faq-group']}>
                    <h2 className={classes['faq-group-title']}>Informasi Sering Ditanyakan</h2>
                    <div className={classes['fav-question-group']}>
                        <Collapse
                            expandIconPlacement="start"
                            expandIcon={({ isActive }) => {
                                if (!isActive) {
                                    return <IconExpandDown />;
                                }
                                return <IconExpandUp />;
                            }}
                            className={collapseClasses['collapse-membership']}
                            bordered={false}
                        >
                            {favouriteQuestions?.map((content: any, index) => {
                                return (
                                    <Collapse.Panel
                                        key={index}
                                        header={<PanelTitle title={content.title} />}
                                        className={collapseClasses['collapse-membership-item']}
                                    >
                                        <div
                                            className={classes['collapse-container']}
                                            dangerouslySetInnerHTML={{ __html: content.answer }}
                                        />
                                    </Collapse.Panel>
                                );
                            })}
                        </Collapse>
                    </div>
                </div>
                {/* FAQ group section */}
                <div className={classes['faq-group']}>
                    <h2 className={`${classes['faq-group-title']} ${classes['faq-group-color']} `}>
                        Pertanyaan Berdasarkan Topik Anda
                    </h2>
                    <div className={classes['faq-topics']}>
                        <Row gutter={[16, 16]} className={classes['faq-topics-row']}>
                            {FAQCategories.map((category) => {
                                return (
                                    <Col
                                        className={`${classes['faq-topics-col']} gutter-row`}
                                        xs={24}
                                        sm={24}
                                        md={6}
                                        lg={6}
                                        key={`${category.slug}`}
                                    >
                                        <a className={classes['box-topic']} href={`/faq/${category.slug}`}>
                                            {sm ? (
                                                <>
                                                    <ImageC
                                                        width={40}
                                                        height={40}
                                                        src={category.iconUrl}
                                                        alt="topic logo"
                                                    />
                                                    <h3 className={classes['topic-title']}>{category.title}</h3>
                                                    <p
                                                        className={classes['topic-description']}
                                                        dangerouslySetInnerHTML={{
                                                            __html: category.desc,
                                                        }}
                                                    />
                                                </>
                                            ) : (
                                                <Row className="w-full" align="top">
                                                    <Col span={6} className={classes['col-img']}>
                                                        <ImageC
                                                            width={40}
                                                            height={40}
                                                            src={category.iconUrl}
                                                            alt="topic logo"
                                                        />
                                                    </Col>
                                                    <Col span={18}>
                                                        <h3 className={classes['topic-title']}>{category.title}</h3>
                                                        <p
                                                            className={classes['topic-description']}
                                                            dangerouslySetInnerHTML={{
                                                                __html: category.desc,
                                                            }}
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                        </a>
                                    </Col>
                                );
                            })}
                        </Row>
                    </div>
                </div>
                {/* end FAQ group section */}
                {/* <FaqContactUsFooter isFixed={true} /> */}
            </div>
        </div>
    </>);
};

export default ContainerPage;
